module.exports = __webpack_public_path__ + "static/media/City.53d8de0d.png";